export function loadDefaultAmounts(ctx, amounts) {
    return ctx.dispatch('LOAD_INITIAL_AMOUNTS', amounts);
}
